module.exports = __webpack_public_path__ + "resources/img/zoom_server_dedicated_and_cloud_architecture.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_server_dedicated_and_cloud_architecture.png
// module id = 1274
// module chunks = 0